/**
 * A wait for an uploaded file that the author abandoned, rather than one that failed.
 *
 * It still rejects: the promise is what decrements the pending upload count, so abandoning it
 * silently would leave the form refusing every later submit. The caller recognises this type and
 * reports nothing.
 */
export class UploadWaitCancelled extends Error {
  constructor(fileId: string) {
    super(`Stopped waiting for the uploaded file notification (fileId: ${fileId})`);
    this.name = 'UploadWaitCancelled';
  }
}
